import { tokens } from "@/components/Application/theme";
import { IStepLogLine } from "@/components/Procedures/Checklist/utils/Types";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { useTheme } from "@mui/material";

export const StepLogLineStatus: React.FunctionComponent<IStepLogLine> = (props) => {
	const theme = useTheme();

	const colors = tokens(theme.palette.mode);
	if (props.logLine.ArchiveType !== "Status") return null;

	const statusIcon = props.logLine.Status ? (
		<CheckCircleIcon style={{ color: colors.greenAccent[500] }} />
	) : (
		<ErrorIcon style={{ color: colors.redAccent[500] }} />
	);

	return <div>{statusIcon}</div>;
};